import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/Sidebar';
import { Topbar } from '@/components/Topbar';
import { MobileNav } from '@/components/MobileNav';
import { OfflineBanner } from '@/components/OfflineBanner';
import { useCompanyBackground } from '@/app/useCompanyBackground';
import { v } from '@/theme/tokens';

export function AppLayout() {
  useCompanyBackground();

  return (
    <div className="rt-app" style={{ display: 'flex', minHeight: '100vh', background: v('bg') }}>
      {/* The glass skin's backdrop: the company photo the panels sit over,
          chosen by the owner in Настройки. Hidden in the classic skin
          (styles/glass.css). */}
      <div className="rt-backdrop" aria-hidden />
      <div className="desktop-sidebar" style={{ display: 'block' }}>
        <Sidebar />
      </div>
      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <OfflineBanner />
        <Topbar />
        <main
          className="scroll-area app-main"
          style={{ padding: '26px 28px', maxWidth: 1280, width: '100%', margin: '0 auto' }}
        >
          <Outlet />
        </main>
      </div>
      <MobileNav />
    </div>
  );
}
